<template>
    <article class="serieCard">
        <div class="serieCard__image">
          <img :src="image" alt="" />
        </div>
        <div class="serieCard__content">
          <svg width="330" height="183" viewBox="0 0 330 183" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M330 0L0 61.5V183H330V0Z" fill="white" fill-opacity="0.4"/>
            <path d="M0 67L330 24V183H0L0 67Z" fill="#E766B2"/>
            <path d="M0 0L330 61.5V183H0V0Z" fill="#E5007E"/>
          </svg>
          <div class="serieCard__text">
            <img src="images/logo-card.svg" style="opacity: 0;height: 10px;"/>
            <h1 class="serieCard__title u-color-white e-h2-canal">{{title}}</h1>
            <h2 class="serieCard__producer u-color-white e-h3-canal">{{producer}}</h2>
          </div>
        </div>
    </article>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    producer: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.serieCard {
    display: flex;
    position: relative;
    width: 100%;
    padding-bottom: 180%;
    // height: 424px;
    color: var(--color-white);

    @include media('>=m') {
      padding-bottom: 189%;
      // width: 330px;
      // height: 650px;
    }

    &__content {
      position: absolute;
      bottom: 0;
      left: 0;
      // align-self: flex-end;
      display: grid;
      text-align: left;
      grid-row: 2 / span 1;
      z-index: 1;
      width: 100%;

      svg {
        height: auto;
      }
    }

    &__content svg,
    &__text {
      grid-row-start: 1;
      grid-column-start: 1;
      width: 100%;
    }

    &__text {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding: 28px 23px 0;

      @include media('>=m') {
        padding: 39px 34px 0;
      }

      > img {
        width: 54px;
        margin-bottom: 3px;
        height: auto;

        @include media('>=m') {
          margin-bottom: 16px;
          width: 84px;
        }
      }

    }

    &__title,
    &__producer {
      text-align: left;
    }

    // &__title {
    //     // padding: var(--spacing-xs) var(--spacing-s);
    //     // background: linear-gradient(110deg, var(--color-pink) 35%, var(--color-yellow) 65%);
    // }

    // &__producer {
    //     // padding: var(--spacing-xs) var(--spacing-s);
    //     // background: var(--color-white);
    // }

    &__image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
      }
    }
}
</style>
